<p-breadcrumb
  [model]="[{ label: 'Clientes', routerLink: ['/customers'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Clientes</h5>
      <p>Gerencie a base de clientes</p>
    </div>
  </div>
</p-toolbar>

<p-table
  #table
  [value]="customers()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
  class="mt-5"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="fullNameFilter"
          class="block"
          [(ngModel)]="fullNameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome completo"
          fluid
        />
      </div>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="emailFilter"
          class="block"
          [(ngModel)]="emailFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="E-mail"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Nome completo</th>
      <th>E-mail</th>
      <th>Telefone</th>
      <th>Data de nascimento</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.fullName }}</td>
      <td>{{ item.email }}</td>
      <td>
        {{ item.phone }}
      </td>
      <td>{{ item.dateOfBirth | date: "dd/MM/yyyy" }}</td>
      <td>
        <p-button
          icon="ph ph-eye"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/customers/details/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
